var render, staticRenderFns
import script from "./render_string.vue?vue&type=script&lang=js&"
export * from "./render_string.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52bae912')) {
      api.createRecord('52bae912', component.options)
    } else {
      api.reload('52bae912', component.options)
    }
    
  }
}
component.options.__file = "app/javascript/components/render_string.vue"
export default component.exports